<p class="alert-danger">
  <i class="icon-cnt-times-circle"></i>
  Something is invalid, check the error messages above.
</p>
